import { z } from '../utils/zod.js';
import { dataResponse, listResponse, successResponse } from '../utils/response-templates.js';
export const STAFF_ROLES = ['VIEWER', 'SUPPORT', 'BILLING', 'SUPERADMIN'];
export const staffRoleSchema = z.enum(STAFF_ROLES);
export const STAFF_STATES = ['ACTIVE', 'DISABLED'];
export const staffStateSchema = z.enum(STAFF_STATES);
export const STAFF_PERMISSION_NAMES = [
    'users.read',
    'users.manage',
    'billing.manage',
    'signings.manage',
    'audit.read',
    'staff.manage',
    'subscriptions.manage',
    'analytics.read',
    'documents.download',
];
export const staffPermissionSchema = z.enum(STAFF_PERMISSION_NAMES);
export const ADMIN_AUTH_ERROR_CODES = [
    'EStateMismatch',
    'EEmailNotVerified',
    'EDomainNotAllowed',
    'EStaffNotFound',
    'EStaffDisabled',
    'EOidcFailed',
];
export const adminAuthErrorCodeSchema = z.enum(ADMIN_AUTH_ERROR_CODES);
export const staffReasonSchema = z.string().trim().min(1).max(500);
export const staffDtoSchema = z.object({
    id: z.string().uuid(),
    email: z.string(),
    name: z.string(),
    role: staffRoleSchema,
    state: staffStateSchema,
    lastLoginAt: z.string().datetime().nullable(),
    createdAt: z.string().datetime(),
    createdById: z.string().uuid().nullable(),
});
export const staffMeDtoSchema = staffDtoSchema.extend({
    permissions: z.array(staffPermissionSchema),
});
export const staffMeResponseSchema = dataResponse(staffMeDtoSchema);
export const staffResponseSchema = dataResponse(staffDtoSchema);
export const listStaffResponseSchema = listResponse(staffDtoSchema);
export const staffLogoutResponseSchema = successResponse();
export const staffIdParamsSchema = z.object({
    staffId: z.string().uuid(),
});
export const createStaffRequestSchema = z.object({
    email: z.string().trim().toLowerCase().email().max(255),
    name: z.string().trim().min(1).max(150),
    role: staffRoleSchema,
    reason: staffReasonSchema,
});
export const updateStaffRequestSchema = z
    .object({
    role: staffRoleSchema.optional(),
    state: staffStateSchema.optional(),
    reason: staffReasonSchema,
})
    .refine((body) => body.role !== undefined || body.state !== undefined, {
    message: 'Provide role and/or state',
    path: ['role'],
});
export const deleteStaffRequestSchema = z.object({
    reason: staffReasonSchema,
});
